import { createRouter, createWebHashHistory } from "vue-router"
import BasicLayout from "@/views/layouts/basic_layout.vue"
import * as Icons from "@ant-design/icons-vue"

export const routes = [
	{
		path: "/",
		name: "index",
		meta: { title: "login" },
		hidemenu: true,
		redirect: "/login",
		children: [
			{
				path: "/login",
				name: "login",
				hidemenu: true,
				meta: { title: "login", authentication_skip: true },
				component: () => import("@/views/login/Login"),
			},
			{
				path: "/register",
				name: "register",
				hidemenu: true,
				meta: { title: "register", authentication_skip: true },
				component: () => import("@/views/login/Register"),
			},
			{
				path: "/resetuser",
				name: "resetuser",
				hidemenu: true,
				meta: { title: "resetuser", authentication_skip: true },
				component: () => import("@/views/login/ResetUser"),
			},
			{
				path: "/openpage",
				name: "openpage",
				hidemenu: true,
				meta: { title: "resetuser", authentication_skip: true },
				component: () => import("@/views/open/OpenPage"),
			},
			{
				path: "/test",
				name: "test",
				hidemenu: true,
				meta: { title: "test", authentication_skip: true },
				component: () => import("@/views/test/test"),
			},
		],
	},
	{
		path: "/home",
		name: "home",
		meta: { title: "Home" },
		hidemenu: false,
		component: BasicLayout,
		redirect: "/show/shows-board",
		children: [
			{
				path: "/show",
				name: "show",
				meta: {
					title: "Show",
					icon: Icons.VideoCameraOutlined
				},
				hidemenu: false,
				component: () => import("@/views/show/Show"),
				redirect: "/show",
				children: [
					{
						path: "/show/shows-board",
						name: "shows board",
						meta: {
							title: "Shows Board",
							icon: Icons.ProjectOutlined
						},
						hidemenu: false,
						component: () => import("@/views/show/show_board.vue"),
					},
					{
						path: "/show/show-details",
						name: "show details",
						meta: {
							title: "Show Details",
							icon: Icons.ReconciliationOutlined
						},
						hidemenu: false,
						component: () => import("@/views/show/show-center.vue"),
					}
				],
			},
			{
				path: "/turnover",
				name: "turnover",
				meta: {
					title: "Turnover",
					icon: Icons.FundViewOutlined
				},
				hidemenu: false,
				component: () => import("@/views/turnover/Turnover"),
				redirect: "/turnover/turnover-board",
				children: [
					{
						path: "/turnover/turnovers-board",
						name: "turnovers board",
						meta: {
							title: "Turnovers Board",
							icon: Icons.InboxOutlined
						},
						hidemenu: false,
						component: () => import("@/views/turnover/turnovers/turnovers-info.vue"),
					},
					{
						path: "/turnover/turnover-details",
						name: "turnover details",
						meta: {
							title: "Turnover Details",
							icon: Icons.FundViewOutlined
						},
						hidemenu: false,
						component: () => import("@/views/turnover/turnover-center.vue"),
					}
				],
			},
			{
				path: "/bid",
				name: "bid",
				meta: { title: "Bids", icon: Icons.FileProtectOutlined },
				hidemenu: false,
				component: () => import("@/views/turnover/Bid"),
				redirect: "/bid/bid-board",
				children: [
					{
						path: "/bid/bid-board",
						name: "bid board",
						meta: { title: "Bids Board", icon: Icons.UnorderedListOutlined },
						hidemenu: false,
						component: () => import("@/views/bids/bids-info.vue"),
					},
					{
						path: "/bid/bid-details",
						name: "bid details",
						meta: { title: "Bid Details", icon: Icons.FileSearchOutlined },
						hidemenu: false,
						component: () => import("@/views/bids/bids-detail.vue"),
					}
				],
			},

			{
				path: "/stuffing",
				name: "stuffing",
				meta: { title: "Staffing", icon: Icons.TeamOutlined },
				hidemenu: false,
				component: () => import("@/views/stuffing/Stuffing"),
				redirect: "/dept-overview",
				children: [
					{
						path: "/stuffing-board",
						name: "stuffing board",
						meta: { title: "Staffing Board", icon: Icons.ScheduleOutlined },
						hidemenu: false,
						component: () =>
							import("@/views/stuffing/stuffing_detail.vue"),
					},
					{
						path: "/dept-overview",
						name: "dept_overview",
						meta: { title: "Dept Overview", icon: Icons.ApartmentOutlined },
						hidemenu: false,
						component: () =>
							import("@/views/stuffing/dept_overview/dept_overview_new.vue"),
					},
					{
						path: "/studio-crew-overview",
						name: "studio-crew-overview",
						meta: { title: "Studio Crew Overview", icon: Icons.UsergroupAddOutlined },
						hidemenu: false,
						component: () => import("@/views/production/overview/prod-overview"),
					},
					{
						path: "/resource-overview",
						name: "resource-overview",
						meta: { title: "Resource Overview", icon: Icons.BarChartOutlined },
						hidemenu: false,
						component: () =>
							import("@/views/stuffing/resource_overview/resource_overview_new.vue"),
					},
				],
			},
			// {
			// 	path: "/production",
			// 	name: "production",
			// 	meta: { title: "production" },
			// 	hidemenu: false,
			// 	component: () => import("@/views/production/production"),
			// 	children: [
			// 		{
			// 			path: "/prod-test",
			// 			name: "prod-test",
			// 			meta: { title: "Test" },
			// 			hidemenu: false,
			// 			component: () => import("@/views/widgets/generic-form.vue"),
			// 		}
			// 	],
			// },
			{
				path: "/data-center",
				name: "data_center",
				meta: { title: "Data Center", icon: Icons.DatabaseOutlined },
				hidemenu: false,
				component: () => import("@/views/data_center/datacenter_main.vue"),
				children: [

					// {
					// 	path: "/data-center/tttttt",
					// 	name: "ttttttttttttttttttttttttttttt",
					// 	meta: { title: "Time tttttt", icon: ClockCircleOutlined },
					// 	hidemenu: false,
					// 	component: () => import("@/views/finance/components/finance_box.vue"),
					// },

					{
						path: "/data-center/timelogs",
						name: "datacenter_timelogs",
						meta: { title: "Time Logs", icon: Icons.FieldTimeOutlined },
						hidemenu: false,
						component: () => import("@/views/data_center/datacenter_timelogs.vue"),
					},
					{
						path: "/data-center/tasks",
						name: "datacenter_task",
						meta: { title: "Tasks", icon: Icons.CheckSquareOutlined },
						hidemenu: false,
						component: () => import("@/views/data_center/datacenter_tasks.vue"),
					},
					{
						path: "/data-center/shot",
						name: "datacenter_shot",
						meta: { title: "Shots", icon: Icons.AimOutlined },
						hidemenu: false,
						component: () => import("@/views/data_center/datacenter_shots.vue"),
					},
					{
						path: "/data-center/asset",
						name: "datacenter_asset",
						meta: { title: "Assets", icon: Icons.BankOutlined },
						hidemenu: false,
						component: () => import("@/views/data_center/datacenter_assets.vue"),
					},
					{
						path: "/data-center/staff",
						name: "datacenter_staff",
						meta: { title: "Staff", icon: Icons.AccountBookOutlined },
						hidemenu: false,
						component: () => import("@/views/data_center/datacenter_staff.vue"),
					},
					{
						path: "/data-center/department",
						name: "datacenter_department",
						meta: { title: "Department", icon: Icons.ApartmentOutlined },
						hidemenu: false,
						component: () => import("@/views/data_center/datacenter_department.vue"),
					},
					{
						path: "/data-center/project",
						name: "datacenter_project",
						meta: { title: "Projects", icon: Icons.FolderOutlined },
						hidemenu: false,
						component: () => import("@/views/data_center/datacenter_project.vue"),
					},
					{
						path: "/data-center/turnover",
						name: "datacenter_turnover",
						meta: { title: "Turnovers", icon: Icons.DollarOutlined },
						hidemenu: false,
						component: () => import("@/views/data_center/datacenter_turnover.vue"),
					},
					{
						path: "/data-center/crewplan",
						name: "datacenter_crewplan",
						meta: { title: "Crewplan", icon: Icons.SolutionOutlined },
						hidemenu: false,
						component: () => import("@/views/data_center/datacenter_crewplan.vue"),
					},
					{
						path: "/data-center/bids",
						name: "datacenter_bids",
						meta: { title: "Bids", icon: Icons.FileProtectOutlined },
						hidemenu: false,
						component: () => import("@/views/data_center/datacenter_bids.vue"),
					},
					{
						path: "/data-center/task_type",
						name: "datacenter_task_type",
						meta: { title: "TaskType", icon: Icons.AppstoreOutlined },
						hidemenu: false,
						component: () => import("@/views/data_center/datacenter_tasktype.vue"),
					},
					{
						path: "/data-center/task_efficiency",
						name: "datacenter_task_efficiency",
						meta: { title: "TaskEfficiency", icon: Icons.ThunderboltOutlined },
						hidemenu: false,
						component: () => import("@/views/data_center/datacenter_task_efficiency.vue"),
					},
					{
						path: "/data-center/status",
						name: "datacenter_status",
						meta: { title: "Status", icon: Icons.InfoCircleOutlined },
						hidemenu: false,
						component: () => import("@/views/data_center/datacenter_status.vue"),
					}
				],
			},
			{
				path: "/acc-center",
				name: "acc_center",
				meta: { title: "ACC Center", icon: Icons.DollarOutlined },
				hidemenu: false,
				component: () => import("@/views/finance/finance_main.vue"),
				children: [
					{
						path: "/acc-center/timelog_weekly_report",
						name: "acc_center_timelog_weekly_report",
						meta: { title: "Weekly Time Logs", icon: Icons.ClockCircleOutlined },
						hidemenu: false,
						component: () => import("@/views/acc_center/datacenter_timelog_weekly_report.vue"),
					},
					{
						path: "/acc-center/render_farm_task",
						name: "acc-center_render_farm_task",
						meta: { title: "Render Farm Task", icon: Icons.HddOutlined },
						hidemenu: false,
						component: () => import("@/views/acc_center/datacenter_render_cost.vue"),
					}
				],
			},
			{
				path: "/purchaser-showcase",
				name: "purchaser_showcase",
				meta: { title: "Base Showcase", icon: Icons.PlayCircleOutlined, authentication_skip: true },
				hidemenu: false,
				component: () => import("@/views/purchaser_showcase/PurchaserShowcase"),
				children: [
					{
						path: "/reels-video",
						name: "reels-video",
						meta: { title: "Reels", icon: Icons.PlaySquareOutlined, authentication_skip: true },
						hidemenu: false,
						component: () =>
							import("@/views/purchaser_showcase/demo_video/Reels"),
					},
					{
						path: "/demo-video",
						name: "demo_video",
						meta: { title: "ShowTracker Demo", icon: Icons.PlayCircleOutlined, authentication_skip: true },
						hidemenu: false,
						component: () =>
							import("@/views/purchaser_showcase/demo_video/DemoVideo"),
					},
					{
						path: "/bts-video",
						name: "bts_video",
						meta: { title: "Base BTS", icon: Icons.VideoCameraAddOutlined, authentication_skip: true },
						hidemenu: false,
						component: () =>
							import("@/views/purchaser_showcase/demo_video/BaseBTS"),
					},
					{
						path: "/video-manager",
						name: "video_manager",
						meta: { title: "Video Management", icon: Icons.ControlOutlined, authentication_skip: false },
						hidemenu: false,
						component: () =>
							import("@/views/purchaser_showcase/demo_video/VideoManager"),
					},
				],
			},
			{
				path: "/person-info",
				name: "person_info",
				meta: { title: "Your Account", icon: Icons.UserOutlined },
				hidemenu: false,
				component: () => import("@/views/personal_info/PersonalInfo"),
				children: [
					{
						path: "/service-hours",
						name: "service_hours",
						meta: { title: "Service Hours", icon: Icons.FieldTimeOutlined },
						hidemenu: false,
						component: () =>
							import(
								"@/views/show_finance_tracker/service_hours/service_hours"
								),
					},
					{
						path: "/monthly-account-summary",
						name: "monthly_account_summary",
						meta: { title: "Account Summary", icon: Icons.FileTextOutlined },
						hidemenu: false,
						component: () =>
							import(
								"@/views/personal_info/monthly_account_summary/MonthlyAccountSummary"
								),
					},
					{
						path: "/my-transactions",
						name: "my_transactions",
						meta: { title: "Transactions History", icon: Icons.WalletOutlined },
						hidemenu: false,
						component: () =>
							import("@/views/personal_info/my_transactions/MyTransactions"),
					},
					{
						path: "/deposit-info",
						name: "deposit-info",
						meta: { title: "Bank Deposit Detail", icon: Icons.BankOutlined },
						hidemenu: false,
						component: () =>
							import("@/views/personal_info/deposit_info/DepositInfo"),
					},
					{
						path: "/change-password",
						name: "change_password",
						meta: { title: "Change Password", icon: Icons.LockOutlined },
						hidemenu: false,
						component: () =>
							import("@/views/personal_info/change_password/ChangePassword"),
					}
				],
			},
			{
				path: "/admin",
				name: "admin",
				meta: { title: "Admin", icon: Icons.SettingOutlined },
				hidemenu: false,
				component: () => import("@/views/admin/Admin"),
				children: [
					// {
					// 	path: "/tttt",
					// 	name: "tttt",
					// 	meta: { title: "Test Transaction" },
					// 	hidemenu: false,
					// 	component: () =>
					// 		import("@/views/widgets/generic-batch-uploader.vue"),
					// },
					{
						path: "/add-transaction-new",
						name: "add_transaction_new",
						meta: { title: "Add Transaction", icon: Icons.PlusCircleOutlined },
						hidemenu: false,
						component: () =>
							import("@/views/admin/add_transaction/AddTransaction_New"),
					},
					{
						path: "/admin-transactions",
						name: "admin_transactions",
						meta: { title: "Admin Transactions", icon: Icons.ProfileOutlined },
						hidemenu: false,
						component: () =>
							import("@/views/admin/ecom_transactions/EcomTransactions"),
					},
					{
						path: "/control-users",
						name: "control_users",
						meta: { title: "Users Purchase", icon: Icons.ShoppingCartOutlined },
						hidemenu: false,
						component: () => import("@/views/admin/control_users/ControlUsers"),
					},
					{
						path: "/users-info",
						name: "users-info",
						meta: { title: "Users Information", icon: Icons.IdcardOutlined },
						hidemenu: false,
						component: () => import("@/views/admin/users_info/UsersInfo"),
					},
					{
						path: "/show-logs",
						name: "show_logs",
						meta: { title: "Usage Logs", icon: Icons.FileTextOutlined },
						hidemenu: false,
						component: () => import("@/views/user/usage-logs"),
					},
					{
						path: "/permission-manager",
						name: "permission-manager",
						meta: { title: "Permission", icon: Icons.SafetyCertificateOutlined },
						hidemenu: false,
						component: () => import("@/views/user/permission-management"),
					},
					{
						path: "/contact-us",
						name: "contact_us",
						meta: { title: "Contact Us", icon: Icons.MessageOutlined },
						hidemenu: false,
						component: () => import("@/views/admin/contact_us/ContactUs"),
					},
				],
			},
			{
				path: "/import-data",
				name: "import_data",
				meta: { title: "Import Data", icon: Icons.ImportOutlined },
				hidemenu: true,
				component: () => import("@/views/import_data/ImportData"),
				children: [
					{
						path: "/import",
						name: "Import",
						meta: { title: "Import", icon: Icons.UploadOutlined },
						hidemenu: false,
						component: () => import("@/views/import_data/import/import"),
					},
				],
			},
		],
	},
	{
		path: "/403",
		name: "forbidden",
		meta: { title: "Forbidden", authentication_skip: true },
		hidemenu: true,
		component: () => import("@/views/layouts/basic_layout.vue"),
		children: [
			{
				path: "",
				name: "403",
				meta: { title: "403 Forbidden", authentication_skip: true },
				hidemenu: true,
				component: () => import("@/views/Forbidden.vue"),
			},
		],
	},
	{
		path: "/:pathMatch(.*)*",
		name: "not_found",
		meta: { title: "Error" },
		hidemenu: true,
		component: () => import("@/views/layouts/basic_layout.vue"),
		children: [
			{
				path: "",
				name: "404",
				meta: { title: "404 Not Found" },
				hidemenu: true,
				component: () => import("@/views/NotFound.vue"),
			},
		],
	}
]

const router = createRouter({
	history: createWebHashHistory(),
	routes,
})

export default router
